import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import ForcePasswordChange from "@/components/ForcePasswordChange";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, passwordExpired } = useAuth();

  if (user === undefined) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50" data-testid="auth-loading">
        <Loader2 className="h-8 w-8 animate-spin text-[#DD0000]" strokeWidth={1.5} />
      </div>
    );
  }
  if (user === null) return <Navigate to="/login" replace />;
  if (passwordExpired) return <ForcePasswordChange />;
  return <>{children}</>;
};

export default ProtectedRoute;
